export default {
  redeemCode: {
    title: 'Resgatar Código',
    description: 'Insira seu código de resgate abaixo para reivindicar sua recompensa.',
    enterTip: 'Digite seu código de resgate para reivindicar recompensas',
    label: 'Código de Resgate',
    placeholder: 'Insira o código de resgate',
    submit: 'Resgatar',
    redeemBtn: 'RESGATAR',
    submitting: 'Resgatando...',
    success: 'Código resgatado com sucesso!',
    redeemSuccess: 'Código resgatado com sucesso!',
    failed: 'Falha ao resgatar o código, tente novamente.',
    redeemFailed: 'Falha ao resgatar o código, tente novamente.'
  }
};
